module.exports = angular.module('cartographer.map.inspector.data', [])

_ = require 'underscore'

module.exports.directive 'crtDataInspector', $DI (crtLog, crtAuth, crtWorkspace) ->
  return {
    restrict: 'A'
    replace: true
    template: require './data.tpl.html'
    scope:
      featureLayer     : '=' # crtFeatureLayer (see below)
      attributeLayer   : '=' # crtAttributeLayer (see below)
      buckets          : '=' # crtAttributeBuckets (see below)
      features         : '=' # arrayOf (feature)
      selection        : '=' # crtFeatureMapSelection
      inspectorState   : '=' # crtMapInspectorState
      onAttributeClick : '=' # crtAttributeLayer -> void
      onPhotosClick    : '=' # () -> void
      onOptionsClick   : '=' # () -> void
    controllerAs: 'crtDataInspector'
    bindToController: true
    controller: $DI ($scope) ->
      crtDataInspector = this

      crtDataInspector.isLoggedIn = ->
        crtAuth.isLoggedIn()

      # Links to survey view --------------------

      crtDataInspector.showSurveyLink = (feature) ->
        workspace = crtWorkspace.current()
        # Only show the link if we're logged in:
        a = crtDataInspector.isLoggedIn()
        # Only show the link if the feature comes from this workspace:
        b = workspace? && (feature.attributes.workspaceIds ? []).indexOf(workspace.id) >= 0
        # Only show the link if the feature comes from exactly one survey:
        c = (feature.attributes.surveyRefs ? []).length == 1
        a && b && c

      crtDataInspector.surveyLinkHref = (feature) ->
        # HACK: We don't know the type of the survey so we can't put it in the URL.
        # However, the "surveyUpdate" route in Angular doesn't actually make use of the survey type
        # so we're able to put an underscore here instead.
        "/survey/#{feature.attributes.surveyRefs[0].moduleId}/#{feature.attributes.surveyRefs[0].surveyId}"

      crtDataInspector.surveyLinkText = (feature) ->
        "View survey"

      # Attribute selection ---------------------

      crtDataInspector.isSelectedAttribute = (attrId) ->
        crtDataInspector.attributeLayer.id == attrId

      crtDataInspector.selectAttribute = (attr) ->
        if crtDataInspector.inspectorState.layerSelectEnabled()
          crtDataInspector.onAttributeClick(crtDataInspector.featureLayer.attribute(attr.id))
        return

      return
  }
